module.exports = __webpack_public_path__ + "img/windows.7a908008.svg";